var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emd-modal", {
    attrs: {
      "has-header": "",
      "footer-buttons-on-right": "",
      open: _vm.isModalOpen,
    },
    on: { close: _vm.handleClose },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [_c("emd-text", [_vm._v(" " + _vm._s(_vm.$t("title")) + " ")])]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _vm.computedStepComponents
              ? _c(_vm.computedStepComponents, {
                  key: _vm.computedStepComponents,
                  tag: "component",
                  attrs: { isLoading: _vm.isLoading, authError: _vm.authError },
                  on: {
                    create: _vm.handleCreate,
                    submit: _vm.handleSubmit,
                    close: _vm.handleClose,
                    back: _vm.handleBack,
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }